import { c as _c } from "react/compiler-runtime";
import { useDropLinkPreviewToggleControl } from "@/components/waves/drops/useDropLinkPreviewToggleControl";
import DropPartMarkdownWithPropLogger from "@/components/drops/view/part/DropPartMarkdownWithPropLogger";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import React from "react";
import EditDropLexical from "./EditDropLexical";
import WaveDropQuoteWithDropId from "./WaveDropQuoteWithDropId";
interface WaveDropPartContentMarkdownProps {
  readonly mentionedUsers: Array<ApiDropMentionedUser>;
  readonly mentionedWaves: Array<ApiMentionedWave>;
  readonly referencedNfts: Array<ApiDropReferencedNFT>;
  readonly part: ApiDropPart;
  readonly wave: ApiWaveMin;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly drop?: ApiDrop | undefined; // Add drop to check for edited status
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
}
const WaveDropPartContentMarkdown: React.FC<WaveDropPartContentMarkdownProps> = t0 => {
  const $ = _c(42);
  const {
    mentionedUsers,
    mentionedWaves,
    referencedNfts,
    part,
    wave,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    drop,
    onLinkCardActionsActiveChange
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const linkPreviewToggleControl = useDropLinkPreviewToggleControl(drop);
  let t3;
  if ($[0] !== drop || $[1] !== wave) {
    t3 = drop?.serial_no === undefined ? [] : [`${wave.id}:${drop.serial_no}`];
    $[0] = drop;
    $[1] = wave;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const currentQuotePath = t3;
  if (isEditing) {
    const t4 = part.content ?? "";
    let t5;
    if ($[3] !== onSave) {
      t5 = (content, mentions, waves) => {
        if (onSave) {
          onSave(content, mentions, waves);
        }
      };
      $[3] = onSave;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] !== onCancel) {
      t6 = () => {
        if (onCancel) {
          onCancel();
        }
      };
      $[5] = onCancel;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== isSaving || $[8] !== mentionedUsers || $[9] !== mentionedWaves || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== wave.id) {
      t7 = <EditDropLexical initialContent={t4} initialMentions={mentionedUsers} initialWaveMentions={mentionedWaves} waveId={wave.id} isSaving={isSaving} onSave={t5} onCancel={t6} />;
      $[7] = isSaving;
      $[8] = mentionedUsers;
      $[9] = mentionedWaves;
      $[10] = t4;
      $[11] = t5;
      $[12] = t6;
      $[13] = wave.id;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    return t7;
  }
  const t4 = drop?.nft_links;
  const t5 = drop?.id;
  const t6 = drop?.hide_link_preview;
  let t7;
  if ($[15] !== currentQuotePath || $[16] !== linkPreviewToggleControl || $[17] !== mentionedUsers || $[18] !== mentionedWaves || $[19] !== onLinkCardActionsActiveChange || $[20] !== onQuoteClick || $[21] !== part.content || $[22] !== referencedNfts || $[23] !== t4 || $[24] !== t5 || $[25] !== t6) {
    t7 = <DropPartMarkdownWithPropLogger mentionedUsers={mentionedUsers} mentionedWaves={mentionedWaves} referencedNfts={referencedNfts} nftLinks={t4} partContent={part.content} onQuoteClick={onQuoteClick} currentDropId={t5} hideLinkPreviews={t6} quotePath={currentQuotePath} linkPreviewToggleControl={linkPreviewToggleControl} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} />;
    $[15] = currentQuotePath;
    $[16] = linkPreviewToggleControl;
    $[17] = mentionedUsers;
    $[18] = mentionedWaves;
    $[19] = onLinkCardActionsActiveChange;
    $[20] = onQuoteClick;
    $[21] = part.content;
    $[22] = referencedNfts;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== drop) {
    t8 = typeof drop?.updated_at === "number" && drop.updated_at !== drop.created_at && <div className="tw-mt-0.5 tw-text-[10px] tw-font-normal tw-leading-none tw-text-iron-500">(edited)</div>;
    $[27] = drop;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t7 || $[30] !== t8) {
    t9 = <div>{t7}{t8}</div>;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== currentQuotePath || $[33] !== drop || $[34] !== onLinkCardActionsActiveChange || $[35] !== onQuoteClick || $[36] !== part.quoted_drop || $[37] !== wave) {
    t10 = part.quoted_drop?.drop_id && <div className="tw-mt-1.5"><WaveDropQuoteWithDropId dropId={part.quoted_drop.drop_id} partId={part.quoted_drop.drop_part_id} maybeDrop={part.quoted_drop.drop ? {
        ...part.quoted_drop.drop,
        wave
      } : null} onQuoteClick={onQuoteClick} embedPath={drop?.id ? [drop.id] : []} quotePath={currentQuotePath} embedDepth={1} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} /></div>;
    $[32] = currentQuotePath;
    $[33] = drop;
    $[34] = onLinkCardActionsActiveChange;
    $[35] = onQuoteClick;
    $[36] = part.quoted_drop;
    $[37] = wave;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== t10 || $[40] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[39] = t10;
    $[40] = t9;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  return t11;
};
export default WaveDropPartContentMarkdown;